"use server";

import { cookies, getRequestContext } from "@rangojs/router";
import { SessionUser } from "../session";

export async function logoutAction() {
  const ctx = getRequestContext()!;
  cookies().delete("session", { path: "/" });
  ctx.set(SessionUser, null);
}
